import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';

export function requireAuthentication(ReqAuthComponent) {

   class AuthenticatedComponent extends Component {
      componentWillMount() {
         const {isAuthenticated, isAuthenticating} = this.props;
         this.checkAuth(isAuthenticating, isAuthenticated);
      }

      componentWillReceiveProps(nextProps) {
         this.checkAuth(nextProps.isAuthenticated);
      }

      checkAuth(isAuthenticating, isAuthenticated) {
         const {location, dispatch} = this.props;
         if (!isAuthenticated && !isAuthenticating) {
            let redirectAfterLogin = location.pathname;
            dispatch(push(`/login?next=${redirectAfterLogin}`));
         }
      }

      render() {
         const {isAuthenticated} = this.props;
         return (
            <div>
               {isAuthenticated === true
                  ? <ReqAuthComponent {...this.props}/> : ""
               }
            </div>
         )

      }
   }

   AuthenticatedComponent.propTypes = {
      token: PropTypes.string,
      isAuthenticated: PropTypes.bool,
      isAuthenticating: PropTypes.bool,
      location: PropTypes.object,
      dispatch: PropTypes.func
   };

   const mapStateToProps = (state) => ({
      token: state.auth.token,
      isAuthenticated: state.auth.isAuthenticated,
      isAuthenticating: state.auth.isAuthenticating
   });

   return connect(mapStateToProps)(AuthenticatedComponent);
}



// WEBPACK FOOTER //
// ./src/views/AuthenticatedView.js